export default __webpack_public_path__ + "media/src/assets/images/DOT_hazmat_class_2.2-de6fd11ebaeb704d1d7bac5d3579fba2.svg";